import type { SelectOption } from '~/components/ui/forms/Select';

// returns or converts a value into a SelectOption object.
export function toSelectValue<T extends string | number>(
    options: SelectOption<T>[],
    value: string | number | SelectOption<T>,
): SelectOption<T> {
    if (typeof value === 'object') {
        return value;
    }
    const option = options.find((o) => o.value === value);
    if (!option) {
        return { label: String(value), value: value as T };
    }
    return option;
}

// converts an array of strings or numbers into SelectOption objects, if they are not already.
export function toSelectOptions<T extends string | number>(
    options?: (string | number | SelectOption<T>)[],
): SelectOption<T>[] {
    return (options || []).map((o) => {
        if (typeof o === 'object') {
            return o;
        } else {
            return { label: String(o), value: o as T };
        }
    });
}
